// extracted by mini-css-extract-plugin
export default {"active":"CustomToolbar_active__sYpgk"};